module.exports = __webpack_public_path__ + "static/media/bird_fly_page5.ef47e10b.png";